var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"dark":""}},[(this.$store.state.isLogged)?_c('core-toolbar'):_vm._e(),_c('core-view'),(this.$store.state.isLogged)?_c('core-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }